import React from 'react';
import react, { useRef, useLayoutEffect, useEffect, useState } from 'react'
import { Container, Stage } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { JackPotCongratsPopup } from './jackpotInfo/jackPotCongratsPopup';
import { stageOptions } from '../frameModule/constants/gameConstants';
import { configuratedStage } from './helpers/configuratedStage';
import { loadingStore } from '../frameModule/blocks/loading';
import { Providers } from '../../../view/containers';
import { JackpotScene } from './jackpotScene';

import { isMobile } from '../../../helpers';
import './scss/style.scss';

const MOBILE_LANDSCAPE_STAGE_SIZE = { width: 960, height: 540 };

export const JackpotModule: React.FC = observer(() => {
  const refApp = useRef(null);
  const [mobileStageSize, setMobileStageSize] = useState(() => ({
    width: window.innerWidth,
    height: window.innerHeight,
  }));

  useLayoutEffect(() => {
    if (!loadingStore.isAllResourceLoaded) return;
    if (!refApp.current) return;

    configuratedStage(refApp);
  }, []);

  useEffect(() => {
    if (!isMobile()) return;

    const updateMobileStageSize = () => {
      const isLandscape = window.innerWidth > window.innerHeight;
      if (isLandscape) {
        setMobileStageSize(MOBILE_LANDSCAPE_STAGE_SIZE);
      } else {
        setMobileStageSize({ width: window.innerWidth, height: window.innerHeight });
      }
    };

    updateMobileStageSize();
    window.addEventListener('resize', updateMobileStageSize);
    window.addEventListener('orientationchange', updateMobileStageSize);

    return () => {
      window.removeEventListener('resize', updateMobileStageSize);
      window.removeEventListener('orientationchange', updateMobileStageSize);
    };
  }, []);


  return (
    <div className={isMobile() ? 'canvas-wrapper' : 'canvas-web-wrapper'}>
      <Stage
        id='jackpotCanvas'
        ref={refApp}
        width={isMobile() ? mobileStageSize.width : 1440}
        height={isMobile() ? mobileStageSize.height : 810}
        options={stageOptions}
      >
        <Providers>
          <Container {...({ name: 'JackPotModuleContainer' } as any)}>
            <JackPotCongratsPopup />
            <JackpotScene />
          </Container>
        </Providers>
      </Stage>
    </div>
  );
});
